import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Box, Grid, MenuItem, Typography } from "@material-ui/core";
import { get } from "lodash";

import {
  galleryEventDropdownOptions,
  allGalleryEventDropdownOptions,
  allAlbumDropdownOptions,
} from "../v2_actions/dropdown_options";

import { GalleryFormSectionHeading } from "./GalleryFormSectionHeading";
import { SessionNameFormField } from "./SessionNameFormField";
import { GalleryDateFormField } from "./GalleryDateFormField";
import { GalleryShotAtTimeFormField } from "./GalleryShotAtTimeField";
import { GalleryActivityFormField } from "./GalleryActivityFormField";
import { GalleryLocationFormField } from "./GalleryLocationFormField";
import { GalleryHideFormField } from "./GalleryHideFormField";
import { GalleryPriceSelector } from "./form/GalleryPriceSelector";
import { GalleryEventDetailsSection } from "./GalleryEventDetailsSection";
import { GalleryPasswordFormField } from "./GalleryPasswordFormField";

export const GalleryFields = ({
  classes,
  MenuClass,
  formProps,
  openSports,
  setOpenSports,
  activityTags,
  setActivityTags,
  selectedGallery,
  activity_tag_options,
  setEventGallery,
  gallery,
  gallery_id,
  galleryType,
}) => {
  const [sessionNameVal, setSessionNameVal] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [openAddGalleryEventLogoDialog, setOpenAddGalleryEventLogoDialog] =
        useState(false);
  const [album, setAlbum] = useState(null);
  const galleryEventOptions = useSelector(() =>
    galleryEventDropdownOptions.getAsOptions(),
  );
  const allGalleryEventOptions = useSelector(() =>
    allGalleryEventDropdownOptions.getAsOptions(),
  );
  const allAlbumOptions = useSelector(() => allAlbumDropdownOptions.getAsOptions());
  const {
    reset,
    control,
    setValue,
    getValues,
    clearErrors,
    handleSubmit,
    formState: { errors },
  } = formProps;
  
  const handleActivityTagChange = (event) => {
    setActivityTags(event.target.value);
  };
  
  const handleHideGallery = (event) => {
    const isAvailableToPurchase = event.target.checked;
    setValue("available_to_purchase", isAvailableToPurchase, {
      shouldValidate: true,
    });
  };

  const handleAddGalleryEventLogo = (event) => {
    const addLogoIsChecked = event.target.checked;
    setValue("add_gallery_event_logo", addLogoIsChecked, {
      shouldValidate: true,
    });
    if (addLogoIsChecked) {
      setOpenAddGalleryEventLogoDialog(true);
    }
  };

  const handleCloseCustomGalleryEventLogoDialog = () => {
    setOpenAddGalleryEventLogoDialog(false);
  };

  const handleIndexGalleryForFacialRecognition = (event) => {
    const isExistingGallery = get(selectedGallery, "id");
    const wasAlreadyIndexed = get(selectedGallery, "can_index_for_facial_recognition");

    const NoTurningOffIfAlreadyIndexed = (
      isExistingGallery && wasAlreadyIndexed && !event.target.checked
    )
    if (NoTurningOffIfAlreadyIndexed) {
      return;
    }

    setValue(
      "can_index_for_facial_recognition",
      event.target.checked,
      { shouldValidate: true },
    );
  };

  return (
    <>
      <GalleryFormSectionHeading heading="Gallery Details" />
      <Box my={2}>
        <SessionNameFormField
          control={control}
          classes={classes}
          setSessionNameVal={setSessionNameVal}
          isEditorForPhotoArt={false}
        />
      </Box>
      <Box my={2}>
        <GalleryDateFormField
          control={control}
          classes={classes}
          isEditorForPhotoArt={false}
        />
      </Box>
      <Box my={2}>
        <GalleryShotAtTimeFormField
          control={control}
          classes={classes}
          isEditorForPhotoArt={false}
        />
      </Box>
      <Box my={2}>
        <GalleryActivityFormField
          control={control}
          classes={classes}
          MenuClass={MenuClass}
          formProps={formProps}
          openSports={openSports}
          activityTags={activityTags}
          setOpenSports={setOpenSports}
          selectedGallery={selectedGallery}
          isEditorForPhotoArt={false}
          activity_tag_options={activity_tag_options}
          handleActivityTagChange={handleActivityTagChange}
        />
      </Box>
      <Box my={2}>
        <GalleryLocationFormField
          control={control}
          classes={classes}
          formProps={formProps}
          isEditorForPhotoArt={false}
          selectedGallery={selectedGallery}
        />
      </Box>
      <Box my={2}>
        <GalleryHideFormField
          showPassword={showPassword}
          setShowPassword={setShowPassword}
          control={control}
          classes={classes}
          setValue={setValue}
          getValues={getValues}
          formProps={formProps}
          setEventGallery={setEventGallery}
          handleHideGallery={handleHideGallery}
          galleryEventOptions={galleryEventOptions}
          handleAddGalleryEventLogo={handleAddGalleryEventLogo}
          openAddGalleryEventLogoDialog={openAddGalleryEventLogoDialog}
          handleCloseCustomGalleryEventLogoDialog={
            handleCloseCustomGalleryEventLogoDialog
          }
        />
      </Box>
      <GalleryEventDetailsSection
        control={control}
        classes={classes}
        setValue={setValue}
        getValues={getValues}
        formProps={formProps}
        setEventGallery={setEventGallery}
        setAlbum={setAlbum}
        selectedGallery={selectedGallery}
        galleryEventOptions={allGalleryEventOptions}
        albumOptions={allAlbumOptions}
        handleAddGalleryEventLogo={handleAddGalleryEventLogo}
        openAddGalleryEventLogoDialog={openAddGalleryEventLogoDialog}
        handleIndexGalleryForFacialRecognition={
          handleIndexGalleryForFacialRecognition
        }
        handleCloseCustomGalleryEventLogoDialog={
          handleCloseCustomGalleryEventLogoDialog
        }
      />
      <Box my={2}>
        <GalleryPasswordFormField
          showPassword={showPassword}
          setShowPassword={setShowPassword}
          control={control}
          classes={classes}
          setValue={setValue}
          getValues={getValues}
          formProps={formProps}
          setEventGallery={setEventGallery}
          galleryEventOptions={galleryEventOptions}
          handleAddGalleryEventLogo={handleAddGalleryEventLogo}
          openAddGalleryEventLogoDialog={openAddGalleryEventLogoDialog}
          handleCloseCustomGalleryEventLogoDialog={
            handleCloseCustomGalleryEventLogoDialog
          }
        />
      </Box>
      <Grid item xs={12}>
        <GalleryPriceSelector
          gallery={gallery}
          formProps={formProps}
          gallery_id={gallery_id}
          gallery_type={galleryType}
          field_name_prefix="gallery_price"
          isEditorForPhotoArt={false}
        />
      </Grid>
    </>
  );
}
